export const logoSpace = (logoUrl?: string) => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundImage: logoUrl ? `url(${logoUrl})` : 'none',
    backgroundSize: '35px 35px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '50%',
    content: '""',
    display: 'block',
    marginRight: 8,
    height: 35,
    width: 35,
    flexShrink: 0,
  },
});

export const resourceSelectStyles = (selectedRecipientOption: any, isRecipient?: boolean) => ({
  control: (base: any) => ({ ...base, minHeight: 56 }),
  valueContainer: (base: any) => ({ ...base, paddingTop: 4, paddingBottom: 4 }),
  singleValue: (base: any) => ({
    ...base,
    ...(isRecipient && { ...logoSpace(selectedRecipientOption?.logoUrl) }),
  }),
  option: (base: any, { data }: any) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    minHeight: 56,
    paddingTop: 8,
    paddingBottom: 8,
    ...(isRecipient && { ...logoSpace(data.logoUrl) }),
  }),
  menu: (base: any) => ({ ...base, zIndex: 9999 }),
  input: (base: any) => ({
    ...base,
  }),
  placeholder: (base: any) => ({
    ...base,
    ...(isRecipient && { ...logoSpace(selectedRecipientOption?.logoUrl) }),
  }),
});

// Mobile-specific styles with reduced height
export const mobileResourceSelectStyles = (
  selectedRecipientOption: any,
  isRecipient?: boolean
) => ({
  control: (base: any) => ({ ...base, minHeight: 56 }),
  valueContainer: (base: any) => ({ ...base, paddingTop: 4, paddingBottom: 4 }),
  singleValue: (base: any) => ({
    ...base,
    ...(isRecipient && { ...logoSpace(selectedRecipientOption?.logoUrl) }),
  }),
  option: (base: any, { data }: any) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    minHeight: 56,
    paddingTop: 8,
    paddingBottom: 8,
    ...(isRecipient && { ...logoSpace(data.logoUrl) }),
  }),
  menu: (base: any) => ({ ...base, zIndex: 9999 }),
  input: (base: any) => ({
    ...base,
  }),
  placeholder: (base: any) => ({
    ...base,
    ...(isRecipient && { ...logoSpace(selectedRecipientOption?.logoUrl) }),
  }),
});
